import type { InvoicesRepository } from '@/core/invoices'
import type { UseCase } from '@/core/shared'

export const getAllFeeInvoices: UseCase<InvoicesRepository, 'getAllFeeInvoices'> = repository => {
  return async (groupUid, filters) => {
    const invoices = await repository.getAllFeeInvoices(groupUid, filters)

    return invoices
  }
}
